import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';
export { addNotification } from './index';

export const fetchNotifications = createAsyncThunk(
    'notifications/fetchNotifications',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/api/notification/');
            return response.data.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'An unexpected error occurred' });
        }
    }
);

export const markNotificationAsRead = createAsyncThunk(
    'notifications/markAsRead',
    async (notificationId: number, { rejectWithValue }) => {
      try {
        await api.patch(`/api/notification/${notificationId}/read`);
        return notificationId;
      } catch (error: any) {
        return rejectWithValue(error.response?.data);
      }
    }
  );

export const dismissNotification = createAsyncThunk(
    'notifications/dismiss',
    async (notificationId: number, { rejectWithValue }) => {
        try {
        await api.patch(`/api/notification/${notificationId}/dismiss`);
        return notificationId;
        } catch (error: any) {
        return rejectWithValue(error.response?.data);
        }
    }
);
